import { render, staticRenderFns } from "./pusingan_new.vue?vue&type=template&id=055832db"
import script from "./pusingan_new.vue?vue&type=script&lang=js"
export * from "./pusingan_new.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports